import { iOSMobileApp, androidMobileApp } from "./mobile";

export const platform = androidMobileApp
  ? "android"
  : iOSMobileApp
    ? "ios"
    : "web";
